module.exports = __webpack_public_path__ + "static/media/working-herdies.43402838.svg";